import { getDomain } from '@sports-utils/domain';
import { BrandType } from '@/interface/enum';

export function getHost(hostname = '') {
    return getDomain(hostname || window.location.hostname);
}

export function getUrl(envUrl = '', protocol = '') {
    protocol = protocol || window.location.protocol;
    return `${protocol}//${envUrl.replace('{host}', getHost())}`;
}

export function getOddsApiUrl(url: string) {
    const protocol = url.includes('localdev') ? 'http:' : 'https:';
    return getUrl(url, protocol);
}

export function getOddsApiWsUrl(url: string) {
    const protocol = url.includes('localdev') ? 'ws:' : 'wss:';
    return getUrl(url, protocol);
}

export function getKratosUrl() {
    return __URL_KRATOS_CDN__ ? getUrl(__URL_KRATOS_CDN__) : getUrl(__URL_KRATOS__);
}

export function getKratosLiveCourtUrl() {
    return getUrl(__URL_KRATOS_LIVE_COURT__);
}

export function getCasaUrl() {
    return getUrl(__URL_CASA_CDN__);
}

export function getPolluxUrl() {
    return getUrl(__URL_POLLUX__);
}

export function getCasaApiUrl() {
    return getUrl('api-home.{host}');
}

export function getCasinoWidgetUrl() {
    return getUrl(__URL_CASINO_WIDGET_JS__);
}

export function getVirtualSportsUrl() {
    return getUrl(__URL_VIRTUALSPORTS__);
}

// call talos
export function getGamesOpenGameUrl() {
    return getUrl(__URL_GAMES_OPEN_GAME__);
}

// call talos-api which on gke
export function getGamesApiUrl() {
    return getUrl(__URL_GAMES_API__);
}

const SPORTS_PROMOTION_PATH = '/promotions/sports-promotion';
const SCORE_PREDICTION_PROMOTION_PATH = '/promotions/epl-prediction?fromSite=KratosIcon';

/** __URL_PROMOTION__ is the promotion site only; each page adds its own path (Junelson, 2026-10-06). */
export function getSportsPromotionUrl() {
    return `${getUrl(__URL_PROMOTION__)}${SPORTS_PROMOTION_PATH}`;
}

/** B2C Event page of the Score Prediction promotion (TCSP-8392). */
export function getScorePredictionPromotionUrl(): string {
    return `${getUrl(__URL_PROMOTION__)}${SCORE_PREDICTION_PROMOTION_PATH}`;
}

export function getGamesProductSwitchUrl() {
    return getUrl(__URL_GAMES_PRODUCT_SWITCH__);
}

export function getMiniGameUrl() {
    return getUrl(__URL_MINI_GAME_WIDGET_JS__);
}

export function getJackpotUrl() {
    return getUrl(__URL_JACKPOT__);
}

export function getCasinoSubDomainUrl() {
    return getUrl(__URL_CASINO_SUBDOMAIN__);
}

export function getBardApiUrl() {
    return getUrl(__URL_BARD_API__);
}

export function getInfoCenterUrl(brandType: BrandType, isMainDomain: boolean) {
    const infoCenterUrls = [
        {
            brandType: BrandType.Sbobet,
            isMainDomain: true,
            url: 'help.sbobet.com',
        },
        {
            brandType: BrandType.Sbotop,
            isMainDomain: true,
            url: 'help.sbotop.com',
        },
        {
            brandType: BrandType.Sbobet,
            isMainDomain: false,
            url: 'sbobetinformation.com',
        },
        {
            brandType: BrandType.Sbotop,
            isMainDomain: false,
            url: 'sbotopinformation.com',
        },
    ];
    const infoCenterUrl = infoCenterUrls.find(x => x.brandType === brandType && x.isMainDomain === isMainDomain);
    return infoCenterUrl ? getUrl(infoCenterUrl.url) : '';
}

export function getBetGeniusScriptUrl(customerId: string, providerMatchId: string, containerId: string) {
    return `${__BET_GENIUS_SCRIPT__}?customerId=${customerId}&fixtureId=${providerMatchId}&containerId=${containerId}&autoplayEnabled=true&width=100%25&height=100%25`;
}
